import {
  filter,
  isArray,
  isEmpty,
  isNull,
  isPlainObject,
  isString,
  map,
  mapValues,
  pickBy,
} from 'lodash';

export function sanitize(object: any): any {
  if (isString(object)) return _sanitizeString(object);
  if (isArray(object)) return _sanitizeArray(object);
  if (isPlainObject(object)) return _sanitizeObject(object);
  return object;
}

function _sanitizeString(string: string) {
  return isEmpty(string) ? '' : string;
}

function _sanitizeArray(array: any[]) {
  return filter(map(array, sanitize), _isProvided);
}

function _sanitizeObject(object: any) {
  return pickBy(mapValues(object, sanitize), _isProvided);
}

function _isProvided(value: any) {
  const typeIsNotSupported =
    !isNull(value) && !isString(value) && !isArray(value) && !isPlainObject(value);
  return typeIsNotSupported || !isEmpty(value);
}
